import { upGreenRateArrow, downRedRateArrow } from '../../../assets/icons';

const ICON_MAP = {
  true: upGreenRateArrow,
  false: downRedRateArrow,
};
export default ICON_MAP;
